module.exports = __webpack_public_path__ + "static/media/feature.5b81c7eb.svg";